import type { DataTableColumn } from "@/shared/components/common/DataTable";
import { USERS_LIST_DEFAULT_PAGE_SIZE } from "@/features/tenantUsers/usersList";
import type { StudentListRow } from "../types/student.types";

export function getStudentsListingConfig(t: (key: string) => string) {
  return {
    entityLabel: t("students:list.entityLabel"),
    basePath: "/students",
    searchPlaceholder: t("students:list.searchPlaceholder"),
    sampleSheetPath: "/students/bulk-upload",
    bulkUploadPath: "/students/bulk-upload",
    addPath: "/students/add-students",
    addLabel: t("students:list.addStudent"),
    pageSize: USERS_LIST_DEFAULT_PAGE_SIZE,
  } as const;
}

export function getStudentsTableColumns(
  t: (key: string) => string,
): DataTableColumn<StudentListRow>[] {
  return [
    {
      key: "name",
      header: t("students:table.name"),
      render: (row) => `${row.firstName ?? ""} ${row.lastName ?? ""}`.trim(),
    },
    { key: "email", header: t("students:table.email") },
    { key: "gender", header: t("students:table.gender"), render: (row) => row.gender ? row.gender.charAt(0).toUpperCase() + row.gender.slice(1) : "" },
    { key: "class", header: t("students:table.class") },
    { key: "section", header: t("students:table.section") },
    { key: "mobile", header: t("students:table.contact") },
    { key: "accountStatus", header: t("students:table.accountStatus") },
  ];
}
